import { useMemo } from 'react';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';

import { TextField, Radio, FieldData } from 'vopay';

import { PaymentFieldDefault } from './types';

export function useContactDetailsFields(): FieldData<PaymentFieldDefault>[] {
  const { t } = useTranslation('translations', { keyPrefix: 'UseTransactionCreationFields' });
  return useMemo(() => {
    return [
      {
        label: () => t('Fields.contactType.label'),
        fieldName: 'ContactType',
        getInputState: () => 'required',
        showField: () => true,
        renderField: ({ ctx, getFormikData }) => {
          return (
            <Radio
              {...getFormikData<string>({
                onChange: (e) => {
                  ctx.setValues({
                    ...ctx.values,
                    ContactType: e.target.value,
                  });
                  ctx.setTouched({
                    ...ctx.touched,
                    FirstName: false,
                    LastName: false,
                    CompanyName: false,
                    ContactType: true,
                  });
                },
              })}
              variant="outlineShadow"
              noOrdering
              options={{
                individual: t('contactType.individual'),
                business: t('contactType.business'),
              }}
            />
          );
        },
      },
      {
        label: () => t('Fields.firstName.label'),
        fieldName: 'FirstName',
        getInputState: () => 'required',
        showField: (values) => values.Contact === 'new' && values.ContactType === 'individual',
        serializeField: (values) => {
          return values.Contact !== 'new' || values.ContactType === 'individual'
            ? values?.FirstName?.replace(/, /g, ' ').replace(/,/g, '') || ''
            : '';
        },
        renderField: ({ getFormikData }) => {
          const fieldData = getFormikData<string>({});
          return <TextField variant="outlineShadow" placeholder="John" {...fieldData} />;
        },
        validate: () => Yup.mixed().required(),
      },
      {
        label: () => t('Fields.lastName.label'),
        fieldName: 'LastName',
        getInputState: () => 'required',
        showField: (values) => values.Contact === 'new' && values.ContactType === 'individual',
        serializeField: (values) => {
          return values.Contact !== 'new' || values.ContactType === 'individual'
            ? values?.LastName?.replace(/, /g, ' ').replace(/,/g, '') || ''
            : '';
        },
        renderField: ({ getFormikData }) => {
          const fieldData = getFormikData<string>({});
          return <TextField variant="outlineShadow" placeholder="Doe" {...fieldData} />;
        },
        validate: () => Yup.mixed().required(),
      },
      {
        label: () => t('Fields.companyName.label'),
        fieldName: 'CompanyName',
        getInputState: () => 'required',
        showField: (values) => values.Contact === 'new' && values.ContactType === 'business',
        serializeField: (values) => {
          return values.Contact !== 'new' || values.ContactType === 'business'
            ? values?.CompanyName?.replace(/, /g, ' ').replace(/,/g, '') || ''
            : '';
        },
        renderField: ({ getFormikData }) => {
          const fieldData = getFormikData<string>({});
          return <TextField variant="outlineShadow" {...fieldData} />;
        },
        validate: () => Yup.mixed().required(),
      },
    ];
  }, []);
}
